import Tabby from "tabbyjs";

const SELECT = document.querySelector(".tabbyjs__header--select");
if (SELECT !== null) {
    const tabbyInstance = new Tabby("[data-tabs]");
    SELECT.addEventListener("change", () => {
        tabbyInstance.toggle(SELECT.value);
    });
}
